import reducers from './reducers';
import {
  setUnconfirmedOrderHidden,
  saveUnconfirmedOrdersInLocalStorage,
  removeUnconfirmedOrder,
} from './helpers/ordersLocalStorage';

module.exports = {
  ...reducers,
  saveUnconfirmedOrdersInLocalStorage,
  setUnconfirmedOrderHidden,
  removeUnconfirmedOrder,
  ReservationBanner: require('./ReservationBanner'),
};
